var _a;
import { ViolationReportAdditionalReasonApi, ViolationReportReasonApi, } from 'api-typings/users/users';
export var ViolationReportReasonText;
(function (ViolationReportReasonText) {
    ViolationReportReasonText["COPIED_WORK_FROM_USER"] = "They copied my work";
    ViolationReportReasonText["COPIED_WORK_FROM_SOMEONE_ELSE"] = "They copied work from another source";
    ViolationReportReasonText["WORK_DOES_NOT_MATCH_REQUIREMENTS"] = "Work does not match requirements";
    ViolationReportReasonText["EXPLICIT_OR_INAPPROPRIATE_CONTENT"] = "Submitted work with explicit or inappropriate content";
    ViolationReportReasonText["LOW_QUALITY_WORK"] = "Low-quality work";
    ViolationReportReasonText["PUBLIC_DISPLAY_OF_COMMUNICATION_DETAILS"] = "They are publicly displaying their contact information";
    ViolationReportReasonText["INAPPROPRIATE_LANGUAGE"] = "They have been using inappropriate language";
    ViolationReportReasonText["OTHER"] = "Other";
})(ViolationReportReasonText || (ViolationReportReasonText = {}));
export var ReportStep;
(function (ReportStep) {
    ReportStep[ReportStep["REASON"] = 1] = "REASON";
    ReportStep[ReportStep["DESCRIPTION"] = 2] = "DESCRIPTION";
    ReportStep[ReportStep["SUCCESS"] = 3] = "SUCCESS";
})(ReportStep || (ReportStep = {}));
export var VIOLATION_REASON_TEXT_MAPPING = (_a = {},
    _a[ViolationReportReasonText.OTHER] = {
        reason: ViolationReportReasonApi.OTHER,
        additionalReason: ViolationReportAdditionalReasonApi.OTHER,
    },
    _a[ViolationReportReasonText.PUBLIC_DISPLAY_OF_COMMUNICATION_DETAILS] = {
        reason: ViolationReportReasonApi.CONTACTS,
        additionalReason: ViolationReportAdditionalReasonApi.PUBLIC_DISPLAY_OF_COMMUNICATION_DETAILS,
    },
    _a[ViolationReportReasonText.EXPLICIT_OR_INAPPROPRIATE_CONTENT] = {
        reason: ViolationReportReasonApi.OTHER,
        additionalReason: ViolationReportAdditionalReasonApi.EXPLICIT_OR_INAPPROPRIATE_CONTENT,
    },
    _a[ViolationReportReasonText.COPIED_WORK_FROM_USER] = {
        reason: ViolationReportReasonApi.OTHER,
        additionalReason: ViolationReportAdditionalReasonApi.COPIED_WORK_FROM_USER,
    },
    _a[ViolationReportReasonText.COPIED_WORK_FROM_SOMEONE_ELSE] = {
        reason: ViolationReportReasonApi.OTHER,
        additionalReason: ViolationReportAdditionalReasonApi.COPIED_WORK_FROM_SOMEONE_ELSE,
    },
    _a[ViolationReportReasonText.WORK_DOES_NOT_MATCH_REQUIREMENTS] = {
        reason: ViolationReportReasonApi.OTHER,
        additionalReason: ViolationReportAdditionalReasonApi.WORK_DOES_NOT_MATCH_REQUIREMENTS,
    },
    _a[ViolationReportReasonText.LOW_QUALITY_WORK] = {
        reason: ViolationReportReasonApi.OTHER,
        additionalReason: ViolationReportAdditionalReasonApi.LOW_QUALITY_WORK,
    },
    _a[ViolationReportReasonText.INAPPROPRIATE_LANGUAGE] = {
        reason: ViolationReportReasonApi.OTHER,
        additionalReason: ViolationReportAdditionalReasonApi.INAPPROPRIATE_LANGUAGE,
    },
    _a);
